(() => {
  const header = document.querySelector('[data-helinox-header]');
  if (header) {
    const drawer = header.querySelector('[data-helinox-mobile-drawer]');
    const scrim = header.querySelector('[data-helinox-scrim]');
    const toggle = header.querySelector('[data-helinox-menu-toggle]');
    const close = header.querySelector('[data-helinox-menu-close]');
    const setDrawer = (open) => {
      drawer?.classList.toggle('is-open', open);
      scrim?.classList.toggle('is-open', open);
      drawer?.setAttribute('aria-hidden', String(!open));
      toggle?.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('helinox-menu-open', open);
    };
    toggle?.addEventListener('click', () => setDrawer(true));
    close?.addEventListener('click', () => setDrawer(false));
    scrim?.addEventListener('click', () => setDrawer(false));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setDrawer(false); });

    const items = [...header.querySelectorAll('.helinox-nav-item--mega')];
    const closeMega = (except) => items.forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector('.helinox-nav-trigger')?.setAttribute('aria-expanded', 'false');
    });
    items.forEach((item) => {
      const trigger = item.querySelector('.helinox-nav-trigger');
      const open = () => { closeMega(item); item.classList.add('is-open'); trigger?.setAttribute('aria-expanded', 'true'); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', () => { item.classList.remove('is-open'); trigger?.setAttribute('aria-expanded', 'false'); });
      trigger?.addEventListener('focus', open);
      trigger?.addEventListener('click', (event) => {
        if (matchMedia('(hover: hover)').matches && !item.classList.contains('is-open')) { event.preventDefault(); open(); }
      });
    });
    document.addEventListener('click', (event) => { if (!header.contains(event.target)) closeMega(); });
  }

  const hero = document.querySelector('[data-helinox-hero]');
  if (hero) {
    const slides = [...hero.querySelectorAll('[data-helinox-slide]')];
    const dots = [...hero.querySelectorAll('[data-helinox-dot]')];
    let active = 0;
    let timer;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === active));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
    };
    const start = () => { clearInterval(timer); timer = setInterval(() => show(active + 1), 5500); };
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', start);
    start();
  }

  let toastTimer;
  const syncCartCount = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((value) => value.json());
    document.querySelectorAll('.helinox-cart-count').forEach((count) => {
      count.classList.toggle('hidden', !cart.item_count);
      count.textContent = String(cart.item_count);
    });
    return cart;
  };
  const showCartToast = (title) => {
    let toast = document.querySelector('.helinox-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'helinox-cart-toast';
      toast.setAttribute('role', 'status');
      document.body.append(toast);
    }
    toast.innerHTML = `<strong>Item added to your cart</strong><span>${title || 'Your item is ready.'}</span><a href="/cart">VIEW CART</a>`;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4200);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.classList.contains('helinox-quick-add')) return;
    const title = document.querySelector('main h1')?.textContent?.trim() || 'Your item';
    window.setTimeout(() => syncCartCount().catch(() => {}), 900);
    window.setTimeout(async () => {
      await syncCartCount().catch(() => null);
      if (!document.querySelector('#cart-notification.active, cart-drawer.active')) showCartToast(title);
    }, 1800);
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.helinox-quick-add');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Cart request failed');
      const item = await response.json();
      await syncCartCount();
      showCartToast(item.product_title || item.title);
    } catch (_error) {
      window.location.href = '/cart';
    } finally {
      button.disabled = false;
    }
  });
})();
